import { useEffect, useState } from "react";
import "../assets/styles/editor.css";
import { VideoAnnotator } from "../components/VideoAnnotator";
// import { annotationMockData } from "../assets/constants/video_configs";
import { AlertMessageBox } from "../components/AlertMessage";
import { GradientCircularProgress } from "../components/Loader";
import { add_roi_coordinate, get_roi_coordinate, update_roi_coordinate, delete_roi_coordinate, get_collections_labelList, get_all_collections } from "../assets/constants/global_apis";

const availableKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', "a", "b", "d", "e", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "t", "u", "w", "y"];
export default function Annotator() {
  const [currentlabel, setCurrentLabel] = useState('');
  const [videoUrl, setVideoUrl] = useState("");
  const [timings, setTimings] = useState([]);
  const [videoFrameCount, setvideoFrameCount] = useState(0);
  const [isloaded, setisloaded] = useState(false);
  const [collectionLabelset, setCollectionLabelSet] = useState([])
  const [labelsetsAccessKeys, setLabelsetsAccessKeys] = useState({})
  let [labelsLi, setLabelsLi] = useState([]);
  let [roiList, setroiList] = useState([{
    "height": 100,
    "width": 100,
    "x": 0,
    "y": 0
  }]);
  let [annotationData, setannotationData] = useState({})
  let [urlParams, setUrlParams] = useState({})
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    Errortype: "Error",
    title: "",
    message: "",
  });


  const openAlertPopup = () => {
    setShowAlertBox(true);
    setTimeout(function () {
      setShowAlertBox(false);
    }, 2000);
  };

  const deleteRoiCoordinates = (roi_id, roiCoordinate) => {
    delete_roi_coordinate(urlParams.collectionID, roi_id).then((response) => {
      getRoiCoordinates()
    })
      .catch(error => {
        console.error(error);
      })
  }

  const updateRoiCoordinates = (roi_id, roiCoordinate, label) => {
    update_roi_coordinate(urlParams.collectionID, roi_id, roiCoordinate, label).then((response) => {
      getRoiCoordinates()
    })
      .catch(error => {
        console.error(error);
      })
  }


  const addRoiCoordinates = (roiCoordinate, label) => {
    add_roi_coordinate(urlParams.collectionID,
      {
        "label": label,
        "roi_coordinates": roiCoordinate
      }
    ).then((response) => {
      getRoiCoordinates()
    })
      .catch(error => {
        console.error(error);
      })
  }



  const getRoiCoordinates = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const collectionID = params.get('collectionID');
    const backendId = params.get('backendId');
    const collectionPath = params.get('collectionPath');
    get_roi_coordinate(collectionID).then((roiData) => {
      let roiArrayData = getRoiList(roiData)
      if (roiArrayData?.length != 0) {
        setroiList([...roiArrayData]);
        annotationData['roi'] = [...roiArrayData];
        updateAnnotationData(backendId, collectionPath, collectionID, annotationData);
      } else {
        setroiList([{
          "height": 100,
          "width": 100,
          "x": 0,
          "y": 0
        }]);
        annotationData['roi'] = [{
          "height": 100,
          "width": 100,
          "x": 0,
          "y": 0
        }];
        updateAnnotationData(backendId, collectionPath, collectionID, annotationData);
      }
    })
      .catch(error => {
        console.error(error);
      })
  }

  const getRoiList = (roiArray) => {
    let roilist1 = [];
    if (roiArray[0]?.x != 0 || roiArray[0]?.y != 0 || roiArray[0]?.width != 100 || roiArray[0]?.height != 100 || roiArray.length == 0) {
      roilist1.push({
        "height": 100,
        "width": 100,
        "x": 0,
        "y": 0
      })
      roilist1 = [...roilist1, ...roiArray]
    }
    else {
      roilist1 = [...roiArray];
    }
    for (let i = 0; i < roilist1.length; i++) {
      let roi = { ...roilist1[i] };
      roi.x = Math.abs(roi.x)
      roi.y = Math.abs(roi.y)
      roi.width = Math.abs(roi.width)
      roi.height = Math.abs(roi.height)
      roilist1[i] = roi;
    }
    return roilist1;
  }

  const handleGetCollectionLabelsetDetails = (collectionID,selectedLabel) => {
    let tmpAvailableKeys = [...availableKeys];
    get_collections_labelList(collectionID).then((data) => {
      setCollectionLabelSet(data)
      let labelsetAccessKeys = {};
      data?.forEach((item, index) => {
        if (selectedLabel == item.labelSetName) {
          item?.labels?.forEach((item1, index) => {
            tmpAvailableKeys = tmpAvailableKeys.filter((key) => key != item1?.labelAccessKey);
          })
        }
      })
      data?.forEach((item, index) => {
        if (selectedLabel == item.labelSetName) {
          item?.labels?.forEach((item1, index) => {
            labelsetAccessKeys[item1.labelName] = {
              'labelAccessKey': item1?.labelAccessKey ? item1.labelAccessKey : tmpAvailableKeys[0],
              'enableEdit': false
            };
            if ((!item1?.labelAccessKey || item1?.labelAccessKey == '') && tmpAvailableKeys.length > 0) {
              tmpAvailableKeys.shift();
            }
          })
          setLabelsetsAccessKeys(labelsetAccessKeys);
        }
      })
    }).catch((error) => {
      console.error("Error fetching collection labels:", error);
    });
  }


  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const backendId = params.get('backendId');
    const collectionPath = params.get('collectionPath');
    const collectionID = params.get('collectionID');
    let urlParamVal = {
      backendId: backendId,
      collectionPath: collectionPath,
      collectionID: collectionID
    }
    let storedData = sessionStorage.getItem("sublabelAnnotateData")
      ? JSON.parse(sessionStorage.getItem("sublabelAnnotateData"))
      : undefined;
    setUrlParams(urlParamVal)
    let labelslist = [];
    let tmpAvailableKeys = [...availableKeys];
    
    collectionID >= 0 && get_collections_labelList(collectionID).then((data) => {
      setCollectionLabelSet(data)
      let labelsetAccessKeys = {},labelForAccessKey=storedData?.selectedLabel ? storedData?.selectedLabel : data[0]?.labelSetName;
      data?.forEach((item, index) => {
        if (labelForAccessKey == item.labelSetName) {
          item?.labels?.forEach((item1, index) => {
            tmpAvailableKeys = tmpAvailableKeys.filter((key) => key != item1?.labelAccessKey);
          })
        }
      })
      
      data?.forEach((item, index) => {
        if (labelForAccessKey == item.labelSetName) {
          item?.labels?.forEach((item1, index) => {
            labelsetAccessKeys[item1.labelName] = {
              'labelAccessKey': item1?.labelAccessKey ? item1.labelAccessKey : tmpAvailableKeys[0] ? tmpAvailableKeys[0] : null,
              'enableEdit': false
            };
            if ((!item1?.labelAccessKey || item1?.labelAccessKey == '') && tmpAvailableKeys.length > 0) {
              tmpAvailableKeys.shift();
            }
          })
          setLabelsetsAccessKeys(labelsetAccessKeys);
        }
      })
    }).catch((error) => {
      console.error("Error fetching collection labels:", error);
    })
    if (storedData && storedData != undefined && JSON.stringify(urlParamVal) == JSON.stringify(storedData.urlParams)) {
      labelslist = storedData?.labels.map((item, index) => item?.name)
      setVideoUrl(storedData.vidURL);
      setCurrentLabel(storedData.selectedLabel);
      setLabelsLi(labelslist)
      setannotationData(storedData)
      setvideoFrameCount(storedData.details.fps)
      setisloaded(true);
      get_roi_coordinate(collectionID).then((roiData) => {
        let roiArrayData = getRoiList(roiData)
        setroiList([...roiArrayData]);
        storedData['roi'] = [...roiArrayData];
        updateAnnotationData(backendId, collectionPath, collectionID, storedData);
      })
    } else {
      Promise.all([
        fetch(`/api/v1/fetch/stream/${backendId}/${collectionPath}`, {
          method: "GET",
        }).then(async (response) => {
          if (!response.ok) {
            const err = await response.json();
            throw err;
          }
          return response;
        })
          .then((data) => {
            setVideoUrl(data.headers.get('location'));
            setisloaded(true);
          })
          .catch(error => {
            console.error(error);
          }),
        fetch(`/api/v1/annotation/video/${backendId}/${collectionPath.replace(/\//g, "%2F")}?collectionId=${collectionID}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        }).then((response) => response.json())
          .then((data) => {
            let annotateData = data;
            labelslist = annotateData?.labels.map((item, index) => item?.name)
            let label = annotateData?.labels[0]?.name;
            setCurrentLabel(label);
            setLabelsLi(labelslist)
            setannotationData(annotateData)
            setvideoFrameCount(data.details.fps);
            get_roi_coordinate(collectionID).then((roiData) => {
              let roiArrayData = getRoiList(roiData)
              setroiList([...roiArrayData]);
              annotateData['roi'] = [...roiArrayData];
              updateAnnotationData(backendId, collectionPath, collectionID, annotateData);
            })
          })
          .catch(error => {
            console.error(error);
          })
      ])
    }
  }, []);

  const onchangeHandlerLabel = (label, annotatedData) => {
    let indxvl = labelsLi?.indexOf(currentlabel);
    let lablsData = [...annotationData.labels];
    lablsData[indxvl] = {
      id: annotationData.labels[indxvl].id,
      name: annotationData.labels[indxvl].name,
      sublabels: [...annotatedData]
    }
    let annotationDataUpdated = {
      vidURL: videoUrl,
      selectedLabel: label,
      urlParams: { ...urlParams },
      details: { ...annotationData.details },
      labels: lablsData
    }
    sessionStorage.setItem("sublabelAnnotateData", JSON.stringify(annotationDataUpdated));
    window.location.reload();
  };

  const updateAnnotationData = (backendId, collectionPath, collectionID, annotationDataUpdated) => {
    let status = 'Not Started';
    annotationDataUpdated.labels.forEach((item) => {
      item.sublabels.forEach((subitem) => {
        status = subitem?.timings.length > 0 ? 'In-Progress' : status;
      })
    })
    fetch(`/api/v1/annotation/save/video/${backendId}/${collectionPath.replace(/\//g, "%2F")}?collectionId=${collectionID}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        {
          ...annotationDataUpdated,
          "status": status
        }
      )
    }).then(async (response) => {
      if (!response.ok) {
        const error = await response.json();
        throw error;
      }
      return response.json()
    })
  }

  const updateAnnotationBackup = (backendId, collectionPath, collectionID, annotationDataUpdated) => {
    let status = 'Not Started';
    annotationDataUpdated.labels.forEach((item) => {
      item.sublabels.forEach((subitem) => {
        status = subitem?.timings.length > 0 ? 'Completed' : status;
      })
    })
    fetch(`/api/v1/annotation/backup-annotation/video/${backendId}/${collectionPath.replace(/\//g, "%2F")}?collectionId=${collectionID}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...annotationDataUpdated,
        "status": status
      }
      )
    }).then(async (response) => {
      if (!response.ok) {
        const error = await response.json();
        throw error;
      }
      return response.json()
    })
  }
  const getUpdatedAnnotationData = (annotatedData, roiListValues) => {
    let indxvl = labelsLi?.indexOf(currentlabel);
    let lablsData = [...annotationData.labels];
    lablsData[indxvl] = {
      id: annotationData.labels[indxvl].id,
      name: annotationData.labels[indxvl].name,
      sublabels: [...annotatedData]
    }
    let roilist1 = [];
    if (!roiListValues || roiListValues.length == 0 || roiListValues == undefined) {
      if (!roiList || roiList.length == 0 || roiList[0].x != 0 || roiList[0].y != 0 || roiList[0].width != 100 || roiList[0].height != 100) {
        roilist1.push({
          "height": 100,
          "width": 100,
          "x": 0,
          "y": 0
        })
      }
      roilist1 = [...roilist1, ...roiList]
    }
    else if (roiListValues.length > 0) {
      roilist1 = [...roiListValues]
    }
    else {
      roilist1 = [...roilist1, ...roiList]
    }
    for (let i = 0; i < roilist1.length; i++) {
      let roi = { ...roilist1[i] };
      roi.x = Math.abs(roi.x)
      roi.y = Math.abs(roi.y)
      roi.width = Math.abs(roi.width)
      roi.height = Math.abs(roi.height)
      roilist1[i] = roi;
    }
    let annotationDataUpdated = {
      details: { ...annotationData.details },
      labels: lablsData,
      roi: roilist1 ? roilist1 : []
    }
    return annotationDataUpdated;
  }

  const handleSubmit = (annotatedData, roiListValues) => {
    if (annotationData?.labels != undefined) {
      const annotationDataUpdated = getUpdatedAnnotationData(annotatedData, roiListValues);
      const { backendId, collectionPath, collectionID } = urlParams;
      updateAnnotationData(backendId, collectionPath, collectionID, annotationDataUpdated);
      setAlertMessage({
        Errortype: "Success",
        title: "Success",
        message: "annotation meta file exported",
      });
      openAlertPopup();
    }
  }

  const handleSubmitBackup = (annotatedData, roiListValues) => {
    if (annotationData?.labels != undefined) {
      const annotationDataUpdated = getUpdatedAnnotationData(annotatedData, roiListValues);
      const { backendId, collectionPath, collectionID } = urlParams;
      updateAnnotationBackup(backendId, collectionPath, collectionID, annotationDataUpdated);
      setAlertMessage({
        Errortype: "Success",
        title: "Success",
        message: "Backup annotation saved",
      });
      openAlertPopup();
    }
  };

  //   const handleFileChange = (event) => {
  //     const file = event?.target?.files[0];
  //     if (file) {
  //       const url = URL.createObjectURL(file);
  //       setVideoUrl(url);
  //       sessionStorage.setItem("videoUrl", url);
  //     }
  //   };

  const renderEditor = () => {
    return (
      <>
        {isloaded && Object.keys(annotationData).length > 0 && annotationData?.labels.length > 0 &&
          annotationData?.labels.map((item, index) => {
            return (
              <div key={`video_editor_parent_container${index}`}>
                {item?.name == currentlabel ? (
                  <VideoAnnotator
                    videoUrl={videoUrl}
                    urlParams={urlParams}
                    timings={timings}
                    setTimings={setTimings}
                    onchangeHandlerLabel={onchangeHandlerLabel}
                    currentlabel={currentlabel}
                    labelsLi={labelsLi}
                    handleSubmit={handleSubmit}
                    handleSubmitBackup={handleSubmitBackup}
                    addRoiCoordinates={addRoiCoordinates}
                    videoFrameCount={videoFrameCount}
                    updateRoiCoordinates={updateRoiCoordinates}
                    deleteRoiCoordinates={deleteRoiCoordinates}
                    annotationData={{
                      video: annotationData?.video,
                      id: annotationData?.id,
                      labels: [item],
                    }}
                    roiList={roiList}
                    setroiList={setroiList}
                    collectionLabelset={collectionLabelset}
                    labelsetsAccessKeys={labelsetsAccessKeys}
                    setLabelsetsAccessKeys={setLabelsetsAccessKeys}
                    availableKeys={availableKeys}
                    handleGetCollectionLabelsetDetails={handleGetCollectionLabelsetDetails}
                    setCollectionLabelSet={setCollectionLabelSet}
                  />
                ) : (
                  ""
                )}
              </div>
            );
          })}
      </>
    );
  };

  return (
    <div className="overallVideoAnnotatorContainer">
      {/* <input type='file' accept='video/*' onChange={handleFileChange} /> */}
      {videoUrl != "" ? renderEditor() : <div className="initialLoader"> <GradientCircularProgress /></div>}
      <div className='annotatesubmitcontainer'>
        <AlertMessageBox
          showAlertBox={showAlertBox}
          setShowAlertBox={setShowAlertBox}
          alertMessage={alertMessage}
        />
      </div>
    </div>
  );
}

